import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7615f30c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rightTips" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "剩余时间", -1))
const _hoisted_4 = { class: "time" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "当前进度", -1))
const _hoisted_7 = { class: "time" }
const _hoisted_8 = { class: "box box2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font" }, "字体", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_remove = _resolveComponent("remove")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_circle_plus = _resolveComponent("circle-plus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.timeString), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.completedCount) + "/" + _toDisplayString(_ctx.topicTotal), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_icon, {
        color: "#5D3341",
        size: 24,
        onClick: _ctx.lessen
      }, {
        default: _withCtx(() => [
          _createVNode(_component_remove)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _hoisted_9,
      _createVNode(_component_el_icon, {
        color: "#5D3341",
        size: 24,
        onClick: _ctx.enlarge
      }, {
        default: _withCtx(() => [
          _createVNode(_component_circle_plus)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}